/**
 * Reads NEXT_PUBLIC_* overrides with literal property access so Next.js/webpack
 * can inline values in the client bundle (dynamic `process.env[key]` is not inlined).
 */
export function defaultReadEnv(key: string): string | undefined {
  switch (key) {
    case 'NEXT_PUBLIC_API_BASE_URL':
      return process.env.NEXT_PUBLIC_API_BASE_URL;
    case 'NEXT_PUBLIC_WS_BASE_URL':
      return process.env.NEXT_PUBLIC_WS_BASE_URL;
    case 'NEXT_PUBLIC_WIDGET_EHR_BASE_URL':
      return process.env.NEXT_PUBLIC_WIDGET_EHR_BASE_URL;
    default:
      return process.env[key];
  }
}
